import { Text as RText } from 'react-native'

import { motify } from '../core'

export const Text = motify(RText)()
